import React from "react";
import MiddleImageLeft from "../images/homepage/enjoyable-place-desktop.jpg";
import BookingForm from "./BookingForm";

const MiddleBooking = () => {
  return (
    <section className="middle-booking">
      <div className="middle-container">
        <BookingForm />
      </div>
    </section>
  );
};

export default MiddleBooking;
